export default __webpack_public_path__ + "static/media/header.ab643564.png";